/**
 * OrganizationName
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';

// Selectors
import { makeSelectOrganizationValue } from '../../services/organizations/selectors';

interface OwnProps {
    organizationId: string;
}

interface ConnectedProps {
    name?: string | null;
}

type Props = OwnProps & ConnectedProps;

export class OrganizationNameComponent extends React.PureComponent<Props> {
    render(): string | null | undefined {
        const { name } = this.props;

        if (!name) return null;

        return name;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    name: makeSelectOrganizationValue('name')
});

export default connect(mapStateToProps)(OrganizationNameComponent);
